import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TestdriveComponent } from './testdrive.component';
import { ConfirmInfoComponent } from './confirm-info/confirm-info.component';
import { DeactivateGuard } from '../../shared/guards/candeactivate';

const routes: Routes = [
  {
      path: '',
      component: TestdriveComponent,
      canDeactivate:[DeactivateGuard]
  },
  {
      path: 'confirm',
      component: ConfirmInfoComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TestdriveRoutingModule { }
